import React from "react";
import { PieChart } from "@mui/x-charts";
import { Box, CircularProgress, Typography } from "@mui/material";
import theme from "../../utils/theme";

const styles = {
  root: {
    width: "100%",
    height: 260,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  overlayWrapper: {
    position: "absolute",
    top: "45%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
    textAlign: "center",
  },
  countText: {
    fontSize: 36,
    fontWeight: 700,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
  labelText: {
    fontSize: 14,
    fontWeight: 400,
    color: "text.secondary",
  },
};

const PIChart = ({ data }) => {
  return (
    <Box sx={styles.root}>
      {data ? (
        <>
          <PieChart
            series={[
              {
                data: data?.pieData || [],
                innerRadius: 60,
                paddingAngle: 2,
                cornerRadius: 4,
              },
            ]}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "middle" },
              },
            }}
            margin={{ top: 20, bottom: 20, left: 10, right: 10 }}
          />

          <Box sx={styles.overlayWrapper}>
            <Typography sx={styles.countText}>{data.total}</Typography>
            <Typography sx={styles.labelText}>Total RFIs</Typography>
          </Box>
        </>
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
};

export default PIChart;
